import React, { useRef, useMemo } from 'react';
import styled from 'styled-components/macro';

import Container from '../Container';
import { getVh } from '../utils';
import useParallax from '../useParallax';
import useTriggerAnimation from '../useTriggerAnimation';

const Image = styled.img`
  aspect-ratio: 256/503;
  height: auto;

  min-width: 100rem;
  max-width: 130rem;
  width: 11vw;
`;

const Rosemary = () => {
  const ref = {
    figure: useRef<HTMLElement>(null),
    img: useRef<HTMLImageElement>(null)
  }

  const top = useMemo(() => getVh("history", 0), []);

  useTriggerAnimation(ref.figure, top);
  useParallax(ref.img, top, 150);

  return (
    <Container
      ref={ref.figure}
      top={top}
      style={{ left: "80vw" }}
    >
      <Image
        ref={ref.img}
        src="/static/images/fill/rosemary/2.png"
      />
    </Container>
  );
}

export default Rosemary;